// src/Components/Admin/AdminSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';

export default function AdminSidebar() {
  const linkStyle = ({ isActive }) => ({
    display: 'block',
    padding: '12px 16px',
    color: isActive ? '#fff' : '#222',
    background: isActive ? '#1f2937' : 'transparent',
    textDecoration: 'none',
    borderRadius: 6,
    margin: '6px 8px'
  });

  return (
    <aside style={{ width: 220, background: '#fff', borderRight: '1px solid #e5e7eb' }}>
      <div style={{ padding: 16, borderBottom: '1px solid #eee' }}>
        <h3 style={{ margin: 0 }}>Old Machine Admin</h3>
      </div>
      <nav style={{ padding: 8 }}>
        <NavLink to="/admin/users" style={linkStyle}>Users</NavLink>
        <NavLink to="/admin/listings" style={linkStyle}>Listings</NavLink>
        <NavLink to="/admin/plans" style={linkStyle}>Plans</NavLink>
      </nav>
    </aside>
  );
}
